import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function Faq({ lang }) {
  const faqs = [
    {
      q: {
        en: "Is there any maintenance on the vehicle during the rental?",
        th: "มีการดูแลหรือซ่อมบำรุงรถระหว่างการเช่าหรือไม่?",
      },
      a: {
        en: "Yes, we provide care and maintenance services to keep the vehicle ready for use throughout the rental period.",
        th: "มี เราให้บริการดูแลและซ่อมบำรุงเพื่อให้รถพร้อมใช้งานตลอดระยะเวลาการเช่า",
      },
    },
    {
      q: {
        en: "Can I rent a JCB for a short-term project?",
        th: "สามารถเช่ารถ JCB สำหรับโครงการระยะสั้นได้หรือไม่?",
      },
      a: {
        en: "Yes, we have flexible rental terms. Whether renting daily, weekly, or long term.",
        th: "ได้แน่นอน เรามีเงื่อนไขการเช่าที่ยืดหยุ่น ไม่ว่าจะเช่ารายวัน รายสัปดาห์ หรือระยะยาว",
      },
    },
    {
      q: {
        en: "What areas do you serve?",
        th: "คุณให้บริการในพื้นที่ใดบ้าง?",
      },
      a: {
        en: "We provide services in Bangkok, Sai Mai, Don Mueang, Rangsit, and nearby provinces. Contact us to confirm your area.",
        th: "เราให้บริการในกรุงเทพฯ สายไหม ดอนเมือง รังสิต และจังหวัดใกล้เคียง ติดต่อเราเพื่อยืนยันพื้นที่ให้บริการ",
      },
    },
    {
      q: {
        en: "Is there a driver available?",
        th: "มีผู้ควบคุมรถให้บริการด้วยหรือไม่?",
      },
      a: {
        en: "Yes, we can provide professional operators for your rental equipment. Please notify your needs in advance.",
        th: "ใช่ เราสามารถจัดหาผู้ควบคุมมืออาชีพสำหรับอุปกรณ์เช่าของคุณได้ กรุณาแจ้งความต้องการล่วงหน้า",
      },
    },
    {
      q: {
        en: "How much does it cost to rent a JCB car?",
        th: "ค่าเช่ารถ JCB เท่าไหร่?",
      },
      a: {
        en: "Price depends on the vehicle type, rental period, and project needs. Contact us at 086-009-2550 for a quote.",
        th: "ราคาขึ้นอยู่กับประเภทของรถ ระยะเวลาการเช่า และความต้องการของโครงการ ติดต่อเราได้ที่ 086-009-2550 เพื่อรับใบเสนอราคา",
      },
    },
    {
      q: {
        en: "What types of JCB vehicles do you have for rent?",
        th: "คุณมีรถ JCB ประเภทใดให้เช่าบ้าง?",
      },
      a: {
        en: "We have excavators, loaders, drills, and other equipment suitable for most construction or landscaping needs.",
        th: "เรามีรถขุด รถตัก รถเจาะ และอุปกรณ์ก่อสร้างอื่น ๆ สำหรับงานขุดเจาะ งานก่อสร้าง งานจัดสวน และงานถมที่ทุกประเภท",
      },
    },
  ];

  return (
    <section className="p-4">
      <Helmet>
        <title>{lang === "th" ? "คำถามที่พบบ่อย - โกโก้ JCB ให้เช่า" : "FAQ - Koko JCB Rental"}</title>
        <meta name="description" content={lang === "th" ? "คำถามที่พบบ่อยเกี่ยวกับบริการเช่ารถ JCB ของเรา" : "Frequently asked questions about our JCB rental services"} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map(faq => ({
              "@type": "Question",
              "name": faq.q[lang],
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.a[lang]
              }
            }))
          })}
        </script>
      </Helmet>
      <h1 className="text-2xl font-bold mb-4">
        {lang === "th" ? "โกโก้ JCB ให้เช่า" : "Koko JCB Rental"} - FAQ
      </h1>
      {faqs.map((item, index) => (
        <div key={index} className="mb-8">
          <h2 className="font-semibold">
            {item.q[lang]}
          </h2>
          <p className="text-gray-700">
            {item.a[lang]}
          </p>
        </div>
      ))}
    </section>
  );
}